import { useUserDetails } from '@/features/_shared/user';
import { FeatureFlag } from '@/services/feature-flags';
import { useFlag } from '@/services/feature-flags/react';

/** Whether the Ask-GX assistant should be offered to the current user (feature flag on, not expired). */
export const useAskGXAvailability = () => {
  const isAiChatEnabled = useFlag(FeatureFlag.AiChatEnabled);
  const { isUserExpired } = useUserDetails();
  return isAiChatEnabled && !isUserExpired;
};
